<template>
  <v-select label="Calidad"
    v-model="selected"
    :item-title="getQualityTypeDetail"
    :items="getQualityTypes" return-object
    :rules="[rules.requiredFieldRule]"
    variant="outlined"
    density="comfortable">
    <template #selection="{ item }">
      {{ getQualityTypeDetail(getRawItem(item)) }}
    </template>
    <template #item="{ item, props }">
      <v-list-item
        v-bind="props"
        :title="getQualityTypeDetail(getRawItem(item))"
      />
    </template>
  </v-select>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'QualityTypeSelector',

  props: {
    modelValue: Object
  },

  data: () => ({
    rules: {
      requiredFieldRule: v => ((v !== null) && (typeof v !== 'undefined') && (v !== '') && (v.id > 0)) || 'Campo requerido.'
    }
  }),

  computed: {
    ...mapGetters('typesModule', ['getQualityTypes']),
    selected: {
      get () { return this.modelValue },
      set (v) {
        this.$emit('update:modelValue', v)
      }
    }
  },

  created () {
    this.$store.dispatch('typesModule/getQualityTypes')
  },

  methods: {
    getQualityTypeDetail (item) {
      if (!item) {
        return ''
      }
      return item.qualityType || ''
    },

    getRawItem (item) {
      return item ? (item.raw || item) : null
    }
  }
}
</script>
